module.exports = new __parcel__URL__("insight-object-timeline-no-filters-skeleton.tpl.4dc1ed7e.svg").toString();